module.exports = __webpack_public_path__ + "static/media/ully.d435d2b5.svg";